import { createContext } from "react";

import { GetLimitsResponse } from "src/gen/schema/configd/api";
import { GetUserContextsResponse } from "src/gen/schema/fred/fapi";
import { UserSessionResponse } from "src/gen/schema/models/user";

/**
 * All the params and callbacks
 * needed to manage login/logout
 * sessions
 */
interface LoginSchema {
  session?: UserSessionResponse | undefined;
  configLimits?: GetLimitsResponse;
  logout: (e?: React.MouseEvent<unknown>) => void;
  changePassword?: (cg: () => void) => void;
  getUserSession: () => Promise<boolean>;
  userContexts?: GetUserContextsResponse | undefined;
  setUserContexts?: (resp: GetUserContextsResponse) => void;
  switchTenant: (id?: string) => void;
}

export const LoginContext = createContext<LoginSchema>({
  session: undefined,
  configLimits: undefined,
  logout: () => {
    window.location.reload();
  },
  getUserSession: () => Promise.resolve(true),
  switchTenant: () => {
    window.location.reload();
  }
});
